// Product Images - Custom Scrollbar
(function() {
  'use strict';
  
  function setupProductScrollbar() {
    console.log('=== Setting up Product Image Scrollbar ===');
    
    // Find product media list
    const productMediaList = document.querySelector('.product__media-list');
    
    if (!productMediaList) {
      console.log('Product media list not found');
      return;
    }
    
    // Get all media items
    const mediaItems = productMediaList.querySelectorAll('.product__media-item, li');
    const itemCount = mediaItems.length;
    
    console.log('Product media items found:', itemCount);
    
    if (itemCount <= 1) {
      console.log('Only 1 image, no scrollbar needed');
      return;
    }
    
    // Find where to insert scrollbar
    const mediaWrapper = document.querySelector('.product__media-wrapper, .product__column-sticky');
    const insertTarget = mediaWrapper || productMediaList.parentElement;
    
    // Check if scrollbar already exists
    const existingScrollbar = insertTarget.querySelector('.product-scrollbar-track');
    if (existingScrollbar) {
      console.log('Scrollbar already exists, removing old one');
      existingScrollbar.remove();
    }
    
    // Create scrollbar elements
    const trackDiv = document.createElement('div');
    trackDiv.className = 'product-scrollbar-track';
    
    const sliderDiv = document.createElement('div');
    sliderDiv.className = 'product-scrollbar-slider';
    sliderDiv.style.width = (100 / itemCount) + '%';
    
    trackDiv.appendChild(sliderDiv);
    
    // Insert scrollbar after the media wrapper
    insertTarget.appendChild(trackDiv);
    
    console.log('✓ Product scrollbar created with width:', (100 / itemCount) + '%');
    
    // Function to update scrollbar position
    function updateScrollbarPosition() {
      let activeIndex = 0;
      
      // Method 1: Check aria-hidden
      mediaItems.forEach((item, index) => {
        const ariaHidden = item.getAttribute('aria-hidden');
        if (ariaHidden === 'false') {
          activeIndex = index;
        }
      });
      
      // Method 2: Check if no aria-hidden found, look for active thumbnail
      if (activeIndex === 0) {
        const activeThumbnail = document.querySelector('.product__media-toggle.is-active, .thumbnail-list__item.is-active');
        if (activeThumbnail) {
          const thumbIndex = activeThumbnail.getAttribute('data-media-position') || activeThumbnail.getAttribute('data-target');
          if (thumbIndex) {
            activeIndex = parseInt(thumbIndex) - 1;
          }
        }
      }
      
      // Method 3: Check scroll position if it's a slider
      if (activeIndex === 0 && productMediaList.scrollLeft !== undefined) {
        const itemWidth = mediaItems[0].offsetWidth;
        if (itemWidth > 0) {
          activeIndex = Math.round(productMediaList.scrollLeft / itemWidth);
        }
      }
      
      // Calculate and set position
      const leftPosition = (activeIndex / itemCount) * 100;
      sliderDiv.style.left = leftPosition + '%';
      
      console.log('Product position updated - Image:', activeIndex + 1, 'Left:', leftPosition + '%');
    }
    
    // Initial position
    setTimeout(updateScrollbarPosition, 100);
    
    // Watch for media item changes
    mediaItems.forEach(item => {
      const observer = new MutationObserver(updateScrollbarPosition);
      observer.observe(item, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    });
    
    // Listen for thumbnail clicks
    const thumbnails = document.querySelectorAll('.product__media-toggle, .thumbnail-list__item button');
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', () => {
        setTimeout(updateScrollbarPosition, 100);
      });
    });
    
    // Listen for scroll events on the media list
    productMediaList.addEventListener('scroll', () => {
      setTimeout(updateScrollbarPosition, 50);
    });
    
    // Listen for navigation button clicks
    const productSection = document.querySelector('.product');
    if (productSection) {
      const prevButton = productSection.querySelector('button[name="previous"]');
      const nextButton = productSection.querySelector('button[name="next"]');
      
      if (prevButton) {
        prevButton.addEventListener('click', () => {
          setTimeout(updateScrollbarPosition, 100);
        });
      }
      
      if (nextButton) {
        nextButton.addEventListener('click', () => {
          setTimeout(updateScrollbarPosition, 100);
        });
      }
    }
    
    console.log('✓ Event listeners attached');
    console.log('=== Product Setup Complete ===');
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupProductScrollbar);
  } else {
    setupProductScrollbar();
  }
  
  // Re-initialize in theme editor
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('.product__media-list')) {
        setTimeout(setupProductScrollbar, 300);
      }
    });
  }
  
})();